export const SEARCHBOX_SUBTITLE_FALLBACK =
  "Search by city or Greystar Community";
